import { useEffect, useState } from "react"


const useToken = (user): string[] => {
    const [token, setToken] = useState<string>('');
    useEffect((): void => {
        const email = user?.user?.email;
        const currentUser = { email: email };
        if (email) {
            fetch(`https://taskla-server-hr.onrender.com/user/${email}`, {
                method: 'PUT',
                headers: {
                    'content-type': 'application/json'
                },
                body: JSON.stringify(currentUser)
            })
                .then(res => res.json())
                .then(data => {
                    const accessToken = data.token;
                    // console.log(data)
                    localStorage.setItem('accessToken', accessToken);
                    setToken(accessToken);
                })
        }

    }, [user]);
    return [token];
}

export default useToken;